import React, { useState } from 'react'
import '../../css/Account/Account.css'
import axios from 'axios';
const SignUp = ({setAuthType}) => {
  const API = process.env.REACT_APP_BACKEND_URL;
  const [name,setName] = useState('');
  const [email,setEmail] = useState('');
  const [company,setCompany] = useState('');
  const [vat,setVat] = useState('');
  const [phone,setPhone] = useState('');
  const [address,setAddress] = useState('');
  const [postcode,setPostcode] = useState(''); 
  const [city,setCity] = useState('');
  const [password,setPassword] = useState('');
  const [confirmPassword,setConfirmPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const account = {
      name,
      email,
      company,
      vat,
      phone,
      address,
      postcode,
      city,
      password,
    }
    if (password !== confirmPassword) {
      alert('A jelszók nem egyeznek!');
      return;
    }
    try {
      await axios.post(`${API}/register`, account);
      setAuthType('login');
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div className="signup">
        <h1>Regisztráció</h1>
        <form action="">
            <input type="text" placeholder="Név" value={name} onChange={(e) => setName(e.target.value)}/>
            <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
            <input type="text" placeholder="Cég Neve" value={company} onChange={(e) => setCompany(e.target.value)}/>
            <input type="text" placeholder="Adószám" value={vat} onChange={(e) => setVat(e.target.value)}/>
            <input type="text" placeholder="Telefonszám" value={phone} onChange={(e) => setPhone(e.target.value)}/>
            <input type="text" placeholder="Cím" value={address} onChange={(e) => setAddress(e.target.value)}/>
            <input type="text" placeholder="Irányítószám" value={postcode} onChange={(e) => setPostcode(e.target.value)}/>
            <input type="text" placeholder="Város" value={city} onChange={(e) => setCity(e.target.value)}/>
            <input type="password" placeholder="Jelszó" value={password} onChange={(e) => setPassword(e.target.value)}/>
            <input type="password" placeholder="Jelszó megerősítése" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>
            <button onClick={handleSubmit}>Regisztráció</button>
        </form>
    </div>
  )
}

export default SignUp